export class BankPluginConfig{
    id: number
    type: string
    clientSecret: string
    clientId: string
    accountNumber: number
    accountNumberVd: string
    account: number
    accountName: string
    paymentMethod: number
    paymentMethodName: string
    keyUrl: string
    crtUrl: string
    webhookRegistered: boolean
    pixKey: string
    branchNumber: number
    billingPortifolio: number

    constructor(type: string) {
        this.type = type;
    }
}